import React from "react";

const PrintStyles = () => (
  <style>
    {`
      @media print {
        body {
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
          background: white !important;
          color: black !important;
          margin: 0.5cm !important;
        }

        * {
          box-shadow: none !important;
          background: transparent !important;
        }

        button,
        .no-print,
        .MuiButton-root {
          display: none !important;
        }

        header,
        nav,
        .navbar,
        .site-footer {
          display: none !important;
        }

        .MuiPaper-root {
          border: none !important;
          box-shadow: none !important;
          padding: 0 !important;
        }

        .print-section {
          display: block;
          page-break-inside: avoid;
          margin-bottom: 12px;
        }

        #root > div:first-child {
          display: none !important;
        }

        .order-items-grid {
          display: grid !important;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)) !important;
          gap: 16px !important;
        }

        .order-items-grid > * {
          min-width: 350px;
          max-width: 100%;
        }

        .keep-together {
          page-break-inside: avoid;
          break-inside: avoid;
          display: flex !important;
          flex-direction: row !important;
          gap: 16px !important;
        }

        .keep-together > * {
          flex: 1 1 0 !important;
          min-width: 0 !important;
        }

        /* 🔥 Real Fix for MUI Grid breaking on print */
        .MuiGrid-container {
          display: flex !important;
          flex-direction: row !important;
          flex-wrap: nowrap !important;
          gap: 16px !important;
        }

        .MuiGrid-item {
          flex: 1 1 0 !important;
          max-width: 100% !important;
          min-width: 0 !important;
        }
      }
    `}
  </style>
);

export default PrintStyles;
